module.exports = __webpack_public_path__ + "img/kai.2f7a35f3.png";